import { useMutation } from '@tanstack/react-query';

import { INITIAL_EMAILS_TO_GENERATE, appStore } from '../../services/appStore';
import { useEmailsQuotaQuery } from '../insights/useEmailsQuotaQuery';
import { invalidateAllInsightsQueries } from '../insights/useInsightsQuery';

type UpdateFunction<T> = (arg: T) => Promise<void>;

export const usePreferencesMutation = <T>({
  mutationKey,
  updateFunction,
  onClose,
}: {
  mutationKey: string[];
  updateFunction: UpdateFunction<T>;
  onClose: () => void;
}) => {
  const emailsQuota = useEmailsQuotaQuery().data?.remaining ?? 0;

  return useMutation({
    mutationKey,
    mutationFn: updateFunction,
    onSuccess: () => {
      invalidateAllInsightsQueries();
      appStore.setRegeneratedOpportunitiesIds([]);
      appStore.setEmailsToGenerateCount(Math.min(emailsQuota, INITIAL_EMAILS_TO_GENERATE));
      appStore.setShowToastAfterSuccessfulGeneration(true);
    },
    onSettled: () => {
      onClose();
    },
  });
};
